module.exports = __webpack_public_path__ + "static/media/ic_expand.feab9067.svg";